import React, { useEffect, useState } from "react";
import { useBreadcrumbs } from '../context/BreadcrumbContext';
import coreAPIService from "../apiServices/coreAPIService";
import { BlockHtml, BlockHtmlApiResponse, Section, OverviewApiResponse, } from "../interfaces/overview";
import { Modal } from 'antd';
import { CTW_API_ENDPOINT } from "../utils";
import { toast } from "../common/Popover";
import { useNavigate } from 'react-router-dom';
import Heading from "../common/Heading";
// import { sanitizeHtml } from "../utils/sanitize";
import HomeSkeleton from "../loaders/HomeSkeleton";



const Homepage: React.FC = () => {
  const { setBreadcrumbs } = useBreadcrumbs();
  const [data, setData] = useState<Section[] | null>(null)
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalState, setModalState] = useState<{ [key: number]: boolean }>({});
  const [activeModalContent, setActiveModalContent] = useState<{
    modalHTML: string;
    modalCSS: string;
  } | null>(null);
  const navigate = useNavigate();
  const [videoUrl, setVideoUrl] = useState<string>("")

  const openModal = async (index: number, id: number) => {
    try {
      const blockHtml = await coreAPIService.get<BlockHtmlApiResponse>(CTW_API_ENDPOINT, `v2/landing-page/get-widget-data/${id}`);
      let htmlcontent: BlockHtml
      if (blockHtml?.meta?.code === 200) {
        htmlcontent = blockHtml.data
        setActiveModalContent(htmlcontent ? { modalHTML: htmlcontent.html, modalCSS: htmlcontent.css } : null);
        setModalState((prev) => ({ ...prev, [index]: true }));
      }
    } catch (error) {
      toast("error", "Error loading widget data", 2)
    }
  };

  const closeModal = (index: number) => {
    setModalState((prev) => ({ ...prev, [index]: false }));
    setActiveModalContent(null);
  };

  useEffect(() => {
    setBreadcrumbs([
      {
        title: <div className="text-lg cursor-pointer" onClick={() => navigate(`/home`)}>Home</div>,
      },
    ]);
  }, [setBreadcrumbs]);

  useEffect(() => {
    fetchOverviewData();
  }, []);

  const fetchOverviewData = async () => {
    try {
      const result = await coreAPIService.get<OverviewApiResponse>(CTW_API_ENDPOINT, 'v2/landing-page/get-homepage-data');

      if (result?.meta?.code === 200 && result?.meta?.status === true) {
        setData(result.data);
        if (result?.data) {
          result.data?.map((item, index) => {
            if (item.section === 2) {
              setVideoUrl(item.videoUrl || "")
            }
          })
        }
      } else {
        setData(null)
        setError("Failed to load data");
      }
    } catch (err) {
      setData(null);
      setError("Failed to load data");
      // navigate('/error')
    }
    setLoading(false);
  };


  const openVideoModal = () => {
    const video = document.getElementById("homepageVideo") as HTMLVideoElement;
    if (video && video.paused) {
      video.play();
    } else if (video) {
      video.play().catch((error) => {
        // Video play error handled silently
      });
    }
    if (video && video.paused) {
      video.play();
    }
    setIsModalOpen(true);
  }
  const handleCancel = () => {
    const video = document.getElementById("homepageVideo") as HTMLVideoElement;
    if (video && !video.paused) {
      video.pause();
    }
    setIsModalOpen(false);
  };

  const ClickToChatAds = (data: Section[]) => {
    return (
      <>
        {/* Overview Section */}
        {data.map((item, index) => {
          if (item.section === 1) {
            return (
              <React.Fragment key={`section-1-${index}`}>
                <section className="px-10 py-2">
                  <div className="bg-white shadow-md rounded-lg p-6">
                    <Heading title={item.title} />
                    <p className="text-slate-700 text-base"
                      dangerouslySetInnerHTML={{ __html: item.body || "" }}
                    />
                  </div>
                </section>
              </React.Fragment>
            );
          }

          // Click To Chat Ads Section
          if (item.section === 2) {
            return (
              <React.Fragment key={`section-2-${index}`}>
                <section className="px-10 py-2">
                  <div className="bg-white shadow-md rounded-lg p-6">
                    <Heading title={item.title} />
                    <div className="flex items-start space-x-6 ">
                      <div className="w-1/2"
                      // onClick={() => openVideoModal()}
                      >
                        <div className="relative">
                          <img src={item.imageUrl || "b.png"} alt="Video Thumbnail" className="rounded-lg shadow" />
                          {/* <button className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 rounded-lg">
                            <span className="text-white text-4xl font-bold">▶</span>
                          </button> */}
                        </div>
                      </div>
                      <div className="w-1/2">
                        <div className="text-slate-700 text-base"
                          dangerouslySetInnerHTML={{ __html: item.body || "" }} />
                      </div>
                    </div>
                  </div>
                </section>
              </React.Fragment>
            );
          }

          // Meta Clicks To WhatsApp Ads Section
          if (item.section === 3 && item.partner?.length) {
            return (
              <React.Fragment key={`section-3-${index}`}>
                <section className="px-10 py-2">
                  <div className="bg-white shadow-md rounded-lg p-6">
                    {item.partner.map((widget, widgetIndex) => (
                      <div key={`partner-${widgetIndex}`}>
                        <Heading title={widget.title} />
                        <div className="blocks w-full">
                          {widget.widget.map((block, blockIndex) => (
                            <div
                              key={`widget-${widgetIndex}-block-${blockIndex}`}
                              className="w-full mx-5 cursor-pointer"
                              onClick={() => openModal(blockIndex, block.id)}
                            >
                              <div
                                className="w-full rounded-lg bg-white m-2 border-solid border-[1.5px] border-gray-100"
                              >
                                <img
                                  src={block.imageUrl}
                                  alt={block.content}
                                  className="w-full h-36 rounded-lg"
                                />
                              </div>
                              <p className="body wrap-text content-center text-center w-full cursor-pointer text-slate-700">
                                {block.content}
                              </p>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </section>
              </React.Fragment>
            );
          }

          return null;
        })}
        {Object.keys(modalState).map((index) => (
          <Modal
            key={`modal-${index}`}
            open={modalState[parseInt(index)]}
            onCancel={() => closeModal(parseInt(index))}
            footer={null}
            className="homepage-modal top-10 rounded-xl"
          >
            {activeModalContent && (
              <>
                <style>{activeModalContent.modalCSS}</style>
                <div
                  dangerouslySetInnerHTML={{
                    __html: activeModalContent.modalHTML,
                  }}
                />
              </>
            )}
          </Modal>
        ))}
      </>
    );
  };


  return (
    <>
      {loading ? <HomeSkeleton /> :
        error !== '' ? <div className="px-10 py-10 text-center text-red-500">{error}</div> : <>

          {ClickToChatAds(data as Section[])}
          <Modal className="homepage-modal" open={isModalOpen} onCancel={handleCancel} footer={null}>
            <video id="homepageVideo" controls>
              <source src={`${videoUrl}`} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Modal>
          <div className="hidden  h-[840px] h-[740px] overflow-y-auto my-6 p-5 text-3xl my-2 pb-6 pt-6" ></div>
        </>}
    </>
  );
};

export default Homepage;